/**
 * Add custom styles to Heading block.
 */
const ParagraphOverrides = () => {
  wp.blocks.registerBlockStyle('core/paragraph', {
    name: 'default',
    label: 'Default',
    isDefault: true,
  });

  wp.blocks.registerBlockStyle('core/paragraph', {
    name: 'uppercase',
    label: 'UPPERCASE',
  });

  wp.blocks.registerBlockStyle('core/paragraph', {
    name: 'smalltitle',
    label: 'Small title',
  });

  wp.blocks.registerBlockStyle('core/paragraph', {
    name: 'fade',
    label: 'Fade 50%',
  });

  wp.blocks.registerBlockStyle('core/paragraph', {
    name: 'caption',
    label: 'Photo caption',
  });
};

export default ParagraphOverrides;
